<template>
	<svg
		:width="iconSize"
		:height="iconSize"
		viewBox="0 0 26 25"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M18.4688 2.34375C18.9002 2.34375 19.25 2.69353 19.25 3.125V4.6875H20.0312C21.7571 4.6875 23.1562 6.08661 23.1562 7.8125V19.5312C23.1562 21.2571 21.7571 22.6562 20.0312 22.6562H5.96875C4.24286 22.6562 2.84375 21.2571 2.84375 19.5312V7.8125C2.84375 6.08661 4.24286 4.6875 5.96875 4.6875H6.75V3.125C6.75 2.69353 7.09978 2.34375 7.53125 2.34375C7.96272 2.34375 8.3125 2.69353 8.3125 3.125V4.6875H17.6875V3.125C17.6875 2.69353 18.0373 2.34375 18.4688 2.34375ZM5.96875 10.1562C5.10581 10.1562 4.40625 10.8558 4.40625 11.7188V19.5312C4.40625 20.3942 5.10581 21.0938 5.96875 21.0938H20.0312C20.8942 21.0938 21.5938 20.3942 21.5938 19.5312V11.7188C21.5938 10.8558 20.8942 10.1562 20.0312 10.1562H5.96875ZM15.6963 13C15.911 13 16.1128 13.0809 16.2646 13.2275C16.5782 13.5303 16.5781 14.0226 16.2646 14.3252L12.6934 17.7725C12.5415 17.9191 12.3388 18 12.124 18C11.9094 17.9999 11.7074 17.919 11.5557 17.7725L9.73535 16.0156C9.58351 15.869 9.50002 15.6741 9.5 15.4668C9.5 15.2595 9.58356 15.0646 9.73535 14.918C9.88709 14.7714 10.089 14.6905 10.3037 14.6904C10.5185 14.6904 10.7212 14.7713 10.873 14.918L12.124 16.126L15.1279 13.2275C15.2798 13.0809 15.4815 13 15.6963 13ZM5.96875 6.25C5.10581 6.25 4.40625 6.94956 4.40625 7.8125V9.01465C4.86617 8.74832 5.39904 8.59375 5.96875 8.59375H20.0312C20.601 8.59375 21.1338 8.74832 21.5938 9.01465V7.8125C21.5938 6.94956 20.8942 6.25 20.0312 6.25H5.96875Z"
			:fill="color"
		/>
	</svg>
</template>

<script>
export default {
	name: 'IconSvgRemoveSchedule',
	props: {
		color: {
			type: String,
			default: '#000000',
		},
		size: {
			type: Number,
			default: null,
		},
	},
	computed: {
		iconSize() {
			return this.size ? `${this.size + 6}px` : '44px'
		},
	},
}
</script>

<style scoped></style>
